import {
  createContext,
  useCallback,
  useContext,
  useState,
  type ReactNode,
} from 'react';
import { Icon } from './Icon.js';

export interface ToastOptions {
  title: string;
  body?: string;
  icon?: string;
  duration?: number;
}

type ToastFn = (opts: ToastOptions | string) => void;

interface ActiveToast extends ToastOptions {
  id: string;
}

const ToastCtx = createContext<ToastFn>(() => {});

export function useToast(): ToastFn {
  return useContext(ToastCtx);
}

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<ActiveToast[]>([]);

  const push = useCallback<ToastFn>((opts) => {
    const id = Math.random().toString(36).slice(2);
    const t: ToastOptions = typeof opts === 'string' ? { title: opts } : opts;
    setToasts((prev) => [...prev, { id, ...t }]);
    window.setTimeout(
      () => setToasts((prev) => prev.filter((x) => x.id !== id)),
      t.duration ?? 4200,
    );
  }, []);

  return (
    <ToastCtx.Provider value={push}>
      {children}
      <div className="toast-wrap">
        {toasts.map((t) => (
          <div className="toast" key={t.id}>
            <div className="t-icon" style={{ background: 'var(--accent-soft)', color: 'var(--accent-text)' }}>
              <Icon name={t.icon ?? 'check'} size={15} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: 13.5 }}>{t.title}</div>
              {t.body && (
                <div style={{ fontSize: 12.5, color: 'var(--text-2)', marginTop: 2 }}>
                  {t.body}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}
